<script>

    // SearchRadiusPicker.svelte

    // 9/20 - based on Sydney's new mockups

    import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';

    // TCARE components
    import LocationBar from './LocationBar.svelte';

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiMapMarkerOutline } from '@mdi/js';

    export let store;                                               // Search object

    $: isExpanded = false;
    $: pickerStyle = getPickerStyle(isExpanded);
    $: svgStyle = getSvgStyle(isExpanded);

    onMount(() => {
    })

    const getPickerStyle = () => {
        if (!isExpanded) {
            return 'border: 1px solid var(--tcare-purple); ';
        } else {
            return 'border: 1px solid var(--tcare-white); ';
        }
    }

    const getSvgStyle = () => {
        if (!isExpanded) {
            return 'fill: var(--tcare-purple); ';
        } else {
            return 'fill: var(--tcare-secondary); ';
        }
    }



</script>

<style>
    .radius-picker-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        overflow: hidden;
    }

    .radius-picker {
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--tcare-purple);
        border-radius: 50%;
    }

    .distance-area {
        margin-left: 10px;
        font-size: 16px;
        font-weight: 800;
        color: var(--tcare-purple);
    }

    .loc-area {
        overflow: hidden;
    }


    :global(.radius-picker svg) {
        width: 65%;
        height: 65%;
        fill: var(--tcare-purple);
        outline: none;
    }

    .radius-picker:hover {
        background-color: var(--tcare-light-purple);
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="radius-picker-wrapper">
    <div class="radius-picker" on:click={() => isExpanded = !isExpanded} style={pickerStyle}>
        <Icon component={Svg} viewBox="0 0 24 24" style={svgStyle}>
            <path d={mdiMapMarkerOutline}/>
        </Icon>
    </div>

    {#if !isExpanded}
        <div class="distance-area" in:fly="{{ x: -20, duration: 500 }}">
            {$store.distance} {$store.distanceUnit}
        </div>
    {/if}

    <div class="loc-area">
        {#if isExpanded}
            <div transition:fly="{{ x: -150, duration: 500 }}">
                <LocationBar {store}/>
            </div>
        {/if}
    </div>
</div>
